import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  header: { id: 'towingRecord.billing.header', defaultMessage: 'Maksutiedot' },
  debtorOrderer: { id: 'towingRecord.billing.debtorType.orderer', defaultMessage: 'Työn tilaaja' },
  debtorHolder: { id: 'towingRecord.billing.debtorType.holder', defaultMessage: 'Ajoneuvon haltija' },
  debtorOwner: { id: 'towingRecord.billing.debtorType.owner', defaultMessage: 'Ajoneuvon omistaja' },
  debtorOther: { id: 'towingRecord.billing.debtorType.other', defaultMessage: 'Muu' },
  resendLabel: { id: 'towingRecord.billing.resend.label', defaultMessage: 'Lähetä uudelleen' },
  resendMessage: {
    id: 'towingRecord.billing.resend.message',
    defaultMessage: 'Haluatko uudelleenlähettää maksulinkin asiakkaalle?',
  },
  resendSuccessTitle: { id: 'towingRecord.billing.resend.successTitle', defaultMessage: 'Maksulinkki lähetetty uudelleen' },
  resendSuccessMessage: {
    id: 'towingRecord.billing.resend.successMessage',
    defaultMessage: 'Maksulinkki on lähetetty uudelleen asiakkaalle.',
  },
  cancelLinkLabel: { id: 'towingRecord.billing.cancelLink.label', defaultMessage: 'Poista maksulinkki' },
  cancelLinkMessage: {
    id: 'towingRecord.billing.cancelLink.message',
    defaultMessage: 'Peruuttaminen avaa maksurivit uudelleen muokattavaksi. Haluatko peruuttaa maksulinkin?',
  },
  cancelLinkSuccessTitle: { id: 'towingRecord.billing.cancelLink.successTitle', defaultMessage: 'Maksulinkki peruutettu' },
  cancelLinkSuccessMessage: {
    id: 'towingRecord.billing.cancelLink.successMessage',
    defaultMessage: 'Maksulinkki on peruutettu ja maksurivit ovat jälleen muokattavissa.',
  },
  cancel: { id: 'towingRecord.billing.cancel', defaultMessage: 'Peruuta' },
  paymentTypeInProgress: { id: 'towingRecord.billing.paymentTypeOption.inProgress', defaultMessage: 'Kuormakirja kesken' },
  paymentTypeReadyForBilling: {
    id: 'towingRecord.billing.paymentTypeOption.readyForBilling',
    defaultMessage: 'Valmis laskutettavaksi',
  },
  paymentTypeCard: { id: 'towingRecord.billing.paymentTypeOption.card', defaultMessage: 'Korttimaksu' },
  paymentTypeCash: { id: 'towingRecord.billing.paymentTypeOption.cash', defaultMessage: 'Käteismaksu' },
  paymentTypeOnlinePayment: { id: 'towingRecord.billing.paymentTypeOption.onlinePayment', defaultMessage: 'Maksulinkki' },
  paymentTypeOnlinePaymentDisabled: {
    id: 'towingRecord.billing.paymentTypeOption.onlinePaymentDisabled',
    defaultMessage: 'Maksulinkki (ota yhteys asiakaspalveluun)',
  },
  selectPaymentType: { id: 'towingRecord.billing.selectPaymentType', defaultMessage: 'Valitse maksutapa' },
  selectPlaceholder: { id: 'towingRecord.billing.selectPlaceholder', defaultMessage: 'Valitse...' },
  debtorTypeLabel: { id: 'towingRecord.billing.debtorTypeLabel', defaultMessage: 'Maksun suorittaja' },
  debtorNameLabel: { id: 'towingRecord.billing.debtorNameLabel', defaultMessage: 'Maksajan nimi' },
  paymentDateLabel: { id: 'towingRecord.billing.paymentDateLabel', defaultMessage: 'Maksupäivä' },
  receiptEmailLabel: {
    id: 'towingRecord.billing.receiptEmailLabel',
    defaultMessage: 'Sähköpostiosoite kuittia varten',
  },
})
